<template>
  <div id="app">
    <notifications transition-name="notification-list" transition-mode="out-in"></notifications>
    <global-header v-if="showHeader"></global-header>
    <router-view :key="$route.fullPath"></router-view>
    <global-footer></global-footer>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import GlobalHeader from 'src/components/GlobalHeader'
import GlobalFooter from 'src/components/GlobalFooter'
import routeMixin from 'src/mixins/routeMixin'
import displayPageNameMixin from 'src/mixins/displayPageNameMixin'
import masterMixin from 'src/mixins/masterMixin'

// 全てのvueコンポーネントに適用
Vue.mixin(displayPageNameMixin)

export default {
  name: 'App',
  data() {
    return {

    }
  },
  created() {
    this.setEnv()
    this.setAxios()
    this.loadUserAndMasters()

    if (!this.isGuestPage()) {
      this.$store.dispatch('user/getMe')
        .then((a) => { /* nothing to do */ })
        .catch(e => {
          this.parseExtParams()
          this.$router.push({ name: 'Login' })
        })
    }
  },
  computed: {
    showHeader() {
      return !this.isGuestPage()
    },
  },
  mixins: [routeMixin, masterMixin],
  methods: {
    setEnv() {
      const environment =
        document.querySelector('meta[name=environment]')
          .attributes.content.value
      Vue.prototype.$isProduction = () => {
        return environment === 'production'
      }
      Vue.prototype.$isStaging = () => {
        return environment === 'staging'
      }
      Vue.prototype.$isDevelopment = () => {
        return !this.$isProduction() && !this.$isStaging()
      }
    },
    setAxios() {
      // base url
      axios.defaults.baseURL = '/api/v1'

      // token
      const token = this.$store.getters['localStorage/serverToken']
      if (token) {
        axios.defaults.headers.Authorization = `Bearer ${token}`
      }
      // go to login if 401 is returned on response
      axios.interceptors.response.use(
        response => {
          return response
        },
        error => {
          let st = 400
          if (error.response) {
            st = error.response.status
          }
          if (st === 401 && !this.isGuestPage()) {
            setTimeout(() => {
              location.href = '/login'
            }, 0)
          }
          return Promise.reject(error)
        }
      )
    },
    parseExtParams() {
      const paths = window.location.pathname.split('/')
      const val = {}
      paths.forEach((path, idx) => {
        if (path.endsWith('-tenken')) {
          val.tenken_type = path
          val.base_id = paths[idx + 1]
        } else if (path === 'detail') {
          val.detail_id = paths[idx + 1]
        }
      })
      if (Object.keys(val).length === 0) {
        return
      }
      this.$store.dispatch('localStorage/set', { key: 'extParams', val })
    },
  },
  components: { GlobalHeader, GlobalFooter }
}
</script>

<style lang="scss">
</style>
